import { render, staticRenderFns } from "./UpdateDementiaKnowledge.vue?vue&type=template&id=5a544161&lang=true&"
import script from "./UpdateDementiaKnowledge.vue?vue&type=script&lang=js&"
export * from "./UpdateDementiaKnowledge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports